import moment from 'moment-timezone';

import type {PlanOverlapAction} from '../types';
import type {DateRangeExclusive} from './date-range';
import type {Child, Plan} from './plan-types';

export const analyzePlanOverlaps = (
    child: Child,
    breakRange: DateRangeExclusive,
    newStartDate: string,
): PlanOverlapAction[] => {
    return child.plans.map(plan => {
        const planStart = moment(plan.from);
        const planEnd = plan.to ? moment(plan.to) : null;

        // Entirely overlapped by break
        if (
            planStart.isSameOrAfter(breakRange.fromInclusive) &&
            planEnd &&
            planEnd.isSameOrBefore(breakRange.toExclusive)
        ) {
            return {type: 'delete', plan};
        }

        // Starts during break, ends after break OR starts during break, doesn't have end date
        if (
            planStart.isAfter(breakRange.fromInclusive) &&
            planStart.isSameOrBefore(breakRange.toExclusive) &&
            ((planEnd && planEnd.isAfter(breakRange.toExclusive)) || planEnd === null)
        ) {
            const updatedPlan: Plan = {
                ...plan,
                from: newStartDate,
            };
            return {type: 'edit', plan: updatedPlan};
        }

        // No overlap
        return {type: 'skip', plan};
    });
};
